import React from 'react';
import { Platform, StyleSheet, Text, View, useWindowDimensions } from 'react-native';

export default function Header() {
  const { width } = useWindowDimensions();

  const titleResponsive: any =
    Platform.OS === 'web'
      ? { fontSize: 'clamp(28px, 7vw, 60px)', whiteSpace: 'nowrap' }
      : { fontSize: Math.max(28, Math.min(60, width * 0.08)) };

  const subtitleResponsive: any =
    Platform.OS === 'web'
      ? {
        fontSize: 'clamp(20px, 3.5vw, 24px)',
        lineHeight: 'clamp(28px, 5vw, 32px)',
      }
      : {
        fontSize: width < 360 ? 16 : 18,
        lineHeight: width < 360 ? 24 : 28,
      };

  return (
    <View style={styles.header}>
      <Text 
        role="heading" 
        aria-level={1}
        numberOfLines={1} 
        adjustsFontSizeToFit 
        ellipsizeMode="tail" 
        style={[styles.title, titleResponsive]}
      >
        <Text style={styles.bracket}>[</Text>
        <Text>CITATION NEEDED</Text>
        <Text style={styles.bracket}>]</Text>
      </Text>

      <Text style={[styles.subtitle, subtitleResponsive]}>
        Find the Paper • Back the Claim
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    alignItems: 'center',
    marginBottom: 48,
  },
  title: {
    fontWeight: 'bold',
    color: '#0f172a',
    marginBottom: 16,
  },
  bracket: {
    color: '#2563eb',
    fontFamily: Platform.OS === 'ios' ? 'Menlo' : 'monospace',
  },
  subtitle: {
    color: '#475569',
    textAlign: 'center',
    maxWidth: 600,
  },
});